import { createComponent } from '../lib';
import { VmControls } from '@vime/core';
import { define } from '../lib';
define('vm-controls', VmControls);
;
export default createComponent('vm-controls', new Set(['hidden', 'fullWidth', 'fullHeight', 'direction', 'align', 'justify', 'pin', 'activeDuration', 'waitForPlaybackStart', 'hideWhenPaused', 'hideOnMouseLeave', 'isAudioView', 'isSettingsActive', 'playbackReady', 'isControlsActive', 'paused', 'playbackStarted']));
//# sourceMappingURL=Controls.jsx.map